import React from 'react';
import './footer.scss';

class Footer extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="Footer">
        <div className="Footer-List">
          <div className="Footer-List-Item">
  	      <a href="">Disclaimer</a>
          </div>
          <div className="Footer-List-Item">
        	  <a href="">About</a>
          </div>
          <div className="Footer-List-Item">
        	  <a href="">AGB</a>
          </div>
          <div className="Footer-List-Item">
        	  <a href="">Tutorial</a>
          </div>
          <div className="Footer-List-Item">
        	  <a href="">Recruitment</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
